// tslint:disable
// this file exists to expose jqeury as globals when imported, since other modules like 'signalr' require the globals.
const windowAsAny = (window as any);

windowAsAny.$ = windowAsAny.jQuery = require('jquery');
